/* eslint-disable no-console */
import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { withRouter } from 'react-router-dom';
import Immutable, { fromJS } from 'immutable';
import { get } from 'lodash-es';

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
// import BlockIcon from '@material-ui/icons/Block';
import CloudUploadIcon from '@material-ui/icons/CloudUpload';
// import CheckBoxIcon from '@material-ui/icons/CheckBox';
// import CancelIcon from '@material-ui/icons/Cancel';
// import CloseIcon from '@material-ui/icons/Close';
import Link from '@material-ui/core/Link';
import IconButton from '@material-ui/core/IconButton';

import { withSnackbar } from 'notistack';

import { CircularProgress } from 'react-md';

import cn from 'classnames';

import moment from 'moment';

import Dropzone from 'react-dropzone';

import * as contractsActions from '../../Services/Contracts/actions';

const LoadingCell = () => (
  <div className="loading cell">
    <CircularProgress
      id="summary-empty-item"
      className="loading-anim-offer"
      scale={0.5}
      style={{ margin: '2em auto' }}
    />
  </div>
);

// eslint-disable-next-line no-unused-vars
class DocumentsBlock extends Component {
  constructor(props) {
    super(props);

    this.state = {
      // eslint-disable-next-line react/no-unused-state
      dropActive: false,
      // eslint-disable-next-line react/no-unused-state
      files: fromJS({}),
    };
  }

  formatDate = ({ date }) => {
    const { i18n } = this.props;
    if (typeof date === 'undefined') return undefined;
    const { compactDateFormat, lang } = i18n;
    moment.locale(lang || 'en');
    return moment(date).format(compactDateFormat);
  };

  hasMissingBlockerDocument = () => {
    const { contract } = this.props;
    const { documents } = contract;
    let rec = false;
    if (!Array.isArray(documents)) return false;
    documents.forEach(document => {
      if (document.blocking && !document.received) {
        rec = true;
      }
    });
    return rec;
  };

  handleSubmitQuote = id => {
    const { submitQuote } = this.props;
    submitQuote(id);
  };

  getReceived = row => {
    const { strings } = this.props;

    if (row.status === 'completed') {
      return get(strings, 'contract.block.documents.table.status.completed', 'Complété');
    } else if (row.attachments.length > 0) {
      return get(strings, 'contract.block.documents.table.status.received', 'Réceptionné');
    } else {
      return get(strings, 'contract.block.documents.table.status.waiting', 'En attente');
    }
  };

  // getBlocker = row => (row.blocking ? <BlockIcon fontSize="small" className="icon block info" /> : '');

  handleAddContractDocument = ({ id, documentId, documentCode }) => {
    const { contract, updateDocumentRequestLine } = this.props;
    const { files } = this.state;
    const file = files.getIn([String(documentId)]);
    if (file) {
      const reader = new FileReader();
      reader.onload = () => {
        const arrayBuffer = reader.result; // Read file as ArrayBuffer
        const buffer = Buffer.from(arrayBuffer); // Convert ArrayBuffer to Buffer

        const transformedFile = {
          fieldname: 'data',
          originalname: file.name,
          encoding: '7bit',
          mimetype: file.type,
          buffer,
          size: file.size,
        };
        updateDocumentRequestLine({
          query: {
            document_request_line: {
              contract: {
                id: parseInt(id, 10),
              }
            },
            document_type: {
              code: documentCode
            },
            attachments: [
              {
                attachment_name: file.name
              },
            ]
          },
          files: [transformedFile],
          contractNumber: contract.contractNumber,
          quoteNumber: contract.quoteNumber,
        });
      };
      reader.onabort = () => console.log('file reading was aborted');
      reader.onerror = () => console.log('file reading has failed');
      try {
        reader.readAsArrayBuffer(file);
      } catch (err) {
        console.log(err);
        console.log(file);
      }
    }
  };

  onDrop = id => acceptedFiles => {
    acceptedFiles.forEach(file => {
      const { files } = this.state;
      const fileList = files.setIn([String(id)], fromJS(file));
      this.setState({ files: fileList });
    });
  };

  // eslint-disable-next-line no-unused-vars
  onDropAccepted = id => file => {
    // const { files  } = this.state;
    // const fileList = files.setIn([id], fromJS(file));
    // this.setState({ files: fileList });
  };

  onDropRejected = id => rejectedFiles => {
    const { errorNotice, strings, enqueueSnackbar } = this.props;
    const msg = strings['contract.error.message.maxfilesize'] || 'Maximum file upload size is 5MB';
    errorNotice(msg, id, rejectedFiles);
    enqueueSnackbar(msg, { variant: 'error' });
  };

  dropZone = row => {
    const { files } = this.state;
    const { id } = row;

    const filesRender = () => {
      const fileList = Immutable.Iterable.isIterable(files.getIn([String(id)]))
        ? files.getIn([String(id)]).toJS()
        : files.getIn([String(id)]);
      if (typeof fileList === 'undefined') return undefined;
      return Array.isArray(fileList) ? (
        fileList.map(file => <span key={file.name}>{`${file.name} - ${file.size} bytes`}</span>)
      ) : (
        <span key={fileList.name}>{`${fileList.name} - ${fileList.size} bytes`}</span>
      );
    };

    return files.getIn([String(id)]) ? (
      filesRender()
    ) : (
      <Dropzone
        onDrop={this.onDrop(String(id))}
        onDropAccepted={this.onDropAccepted(String(id))}
        onDropRejected={this.onDropRejected(String(id))}
        className="dropzone"
        multiple={false}
        maxSize={5000000} // 5MB
      >
        {({ getRootProps, getInputProps, isDragActive }) => (
          <div {...getRootProps()} className={cn('dropzone', { 'dropzone--isActive': isDragActive })}>
            <input {...getInputProps()} />
            {isDragActive ? <p>Drop file here...</p> : <p>Drop file here, or click to select file to upload.</p>}
          </div>
        )}
      </Dropzone>
    );
  };

  handleAttachmentDownload = token => {
    const { actions } = this.props;
    const data = actions.downloadAttachment({ token });
    return `data:image/png;base64,${data}`;
  }

  getGED = row => {
    if (row.status === 'completed' || row.attachments.length > 0) {
      return (
        <Link
          // href={this.handleAttachmentDownload(row.attachments[0].token)}
          download={row.attachments[0].metaData.name}
          className="download-link"
          onClick={() => this.handleAttachmentDownload(row.attachments[0].token)}
        >
          {row.attachments[0].metaData.name}
        </Link>
      );
    }

    if (row.attachments.length === 0) {
      return this.dropZone(row);
    }

    return <></>;
  };

  getAction = row => {
    // eslint-disable-next-line no-unused-vars
    const { strings, contract, deleteContractDocument } = this.props;
    const { files } = this.state;
    const { id, documentDesc } = row;
    // if (contract.status !== 'quote') return undefined;
    return row.attachments.length > 0 ? (
      <></>
    ) : (
      // <IconButton
      //   title={strings['delete.label'] || 'Delete'}
      //   size="small"
      //   key={`action-delete-${String(id)}`}
      //   label={strings['delete.label'] || 'Delete'}
      //   aria-label={strings['delete.label'] || 'Delete'}
      //   color="secondary"
      //   onClick={() =>
      //     deleteContractDocument({
      //       id: contract.id,
      //       documentId: String(id),
      //       attachmentId: row.attachment.id
      //     })
      //   }
      //   onTouchEnd={() =>
      //     deleteContractDocument({
      //       id: contract.id,
      //       documentId: String(id),
      //       attachmentId: row.attachment.id
      //     })
      //   }
      // >
      //   <CancelIcon fontSize="small" className="icon cancel action" />
      // </IconButton>

      <IconButton
        title={strings['upload.label'] || 'Upload'}
        size="small"
        key={`action-upload-${String(id)}`}
        label={strings['upload.label'] || 'Upload'}
        aria-label={strings['upload.label'] || 'Upload'}
        color="primary"
        disabled={!files.getIn([String(id)]) || !!(files.getIn([String(id)]) && files.getIn([String(id)]).size === 0)}
        onClick={() => this.handleAddContractDocument({ id: contract.id, documentId: String(id), documentCode: documentDesc.code })}
        onTouchEnd={() =>
          this.handleAddContractDocument({
            id: contract.id,
            documentId: String(id),
            documentCode: documentDesc.code
          })
        }
      >
        <CloudUploadIcon fontSize="small" className="icon cloud action" />
      </IconButton>
    );
  };

  render() {
    const { strings, contract, loading } = this.props;
    return (
      <div
        className={cn({
          documents: true,
          block: true,
          'missing-blocker-document': this.hasMissingBlockerDocument(),
        })}
      >
        <Table className="table documents">
          <TableHead>
            <TableRow>
              <TableCell>{strings['contract.block.documents.table.rec_name.label'] || 'Name'}</TableCell>
              {/* <TableCell>{strings['contract.block.documents.table.blocking.label'] || 'Blocker'}</TableCell> */}
              <TableCell>{strings['contract.block.documents.table.received.label'] || 'Received'}</TableCell>
              <TableCell>{strings['contract.block.documents.table.reception_date.label'] || 'Received'}</TableCell>
              <TableCell>{strings['contract.block.documents.table.ref_ged.label'] || 'Ref. GED'}</TableCell>
              <TableCell>{strings['contract.block.documents.table.action.label'] || 'Action'}</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {contract.documentRequestLines?.map(row => (
              <TableRow key={row.id}>
                <TableCell component="th" scope="row">
                  {row.documentDesc.name}
                </TableCell>
                {/* <TableCell component="th" scope="row">
                  {this.getBlocker(row)}
                </TableCell> */}
                <TableCell component="th" scope="row">
                  {loading.isUpdatingContractDocuments || loading.isLoadingContractDocuments ? (
                    <LoadingCell />
                  ) : (
                    this.getReceived(row)
                  )}
                </TableCell>
                <TableCell component="th" scope="row">
                  {loading.isUpdatingContractDocuments || loading.isLoadingContractDocuments ? (
                    <LoadingCell />
                  ) : (
                    this.formatDate({ date: row.attachments?.[0]?.metaData?.date })
                  )}
                </TableCell>
                <TableCell component="th" scope="row">
                  {loading.isUpdatingContractDocuments || loading.isLoadingContractDocuments ? (
                    <LoadingCell />
                  ) : (
                    this.getGED(row)
                  )}
                </TableCell>
                <TableCell component="th" scope="row">
                  {loading.isUpdatingContractDocuments || loading.isLoadingContractDocuments ? (
                    <LoadingCell />
                  ) : (
                    this.getAction(row)
                  )}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
    );
  }
}

DocumentsBlock.propTypes = {
  strings: PropTypes.objectOf(PropTypes.string),
  loading: PropTypes.objectOf(PropTypes.bool),
  // eslint-disable-next-line react/forbid-prop-types
  contract: PropTypes.object.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  i18n: PropTypes.object,
  deleteContractDocument: PropTypes.func.isRequired,
  addContractDocument: PropTypes.func.isRequired,
  updateDocumentRequestLine: PropTypes.func.isRequired,
  submitQuote: PropTypes.func.isRequired,
  errorNotice: PropTypes.func,
  enqueueSnackbar: PropTypes.func.isRequired, // eslint-disable-line,
  actions: PropTypes.shape({
    downloadAttachment: PropTypes.func,
  })
};

DocumentsBlock.defaultProps = {
  strings: {},
  loading: {
    isLoadingContractDocuments: false,
  },
  i18n: {
    compactDateFormat: 'D MMM YYYY',
    dateFormat: 'D MMM YYYY',
    fullDateFormat: 'D MMM YYYY / HH:mm',
    hourFormat: 'HH:mm:ss',
    lang: 'fr',
  },
  errorNotice: (...params) => console.log(`errorNotice:: ${params}`),
  actions: {
    downloadAttachment: () => { },
  }
};

const mapStateToProps = state => ({
  attachmentData: state.get('attachmentData'),
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({ ...contractsActions }, dispatch),
});

export default withSnackbar(withRouter(connect(mapStateToProps, mapDispatchToProps)(DocumentsBlock)));
